/* @flow */
import * as React from 'react';

import Styled from './styled';
import Spinner from '../Spinner';

type Props = {
  disabled?: boolean,
  loading?: boolean,
  submit?: boolean,
  text: string,
  onClick: () => mixed,
  appearance?: 'flat' | 'primary' | 'jarvis',
};

export default (props: Props): React$Element<any> => {
  const {
    appearance = 'flat',
    disabled = false,
    loading = false,
    submit,
    text,
    onClick,
    ...otherProps
  } = props;
  let ButtonComponent = Styled.Button;
  if (appearance === 'jarvis') {
    ButtonComponent = Styled.ButtonJarvis;
  }
  const handleClick = !disabled && !loading ? onClick : () => null;
  const content = loading ? <Spinner size={14} /> : text;
  return (
    <ButtonComponent
      type={submit ? 'submit' : 'button'}
      onClick={handleClick}
      disabled={disabled || loading}
      appearance={appearance}
      {...otherProps}
    >
      {content}
    </ButtonComponent>
  );
};
